import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Polyline, useMap } from 'react-leaflet';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const FitBounds = ({ bounds }) => {
  const map = useMap();
  useEffect(() => {
    if (bounds) {
      map.fitBounds(
        [[bounds.south, bounds.west], [bounds.north, bounds.east]],
        { padding: [20, 20] }
      );
    }
  }, [map, bounds]);
  return null;
};

const ActivityMap = ({ activityId }) => {
  const [coordinates, setCoordinates] = useState(null);
  const [bounds, setBounds] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!activityId) return;

    const fetchGPS = async () => {
      try {
        const res = await fetch(
          `${API_BASE}/api/garmin/webhooks/data/activity-gps/${activityId}`
        );
        if (!res.ok) {
          setLoading(false);
          return;
        }
        const data = await res.json();
        if (data.coordinates && data.coordinates.length > 1) {
          setCoordinates(data.coordinates);
          if (data.bounds && data.bounds.north != null) {
            setBounds(data.bounds);
          }
        }
      } catch (err) {
        console.error('Failed to load GPS track:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchGPS();
  }, [activityId]);

  if (loading || !coordinates) return null;

  const center = coordinates[Math.floor(coordinates.length / 2)];

  return (
    <div className="activity-item-map">
      <MapContainer
        center={center}
        zoom={13}
        zoomControl={false}
        dragging={false}
        scrollWheelZoom={false}
        doubleClickZoom={false}
        touchZoom={false}
        attributionControl={false}
        style={{ height: '100%', width: '100%' }}
      >
        <TileLayer
          url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
        />
        <Polyline
          positions={coordinates}
          pathOptions={{
            color: '#FFD700',
            weight: 3,
            opacity: 0.9
          }}
        />
        {bounds && <FitBounds bounds={bounds} />}
      </MapContainer>
    </div>
  );
};

export default ActivityMap;
